<template>
	<div class="card bg-base-100 shadow">
		<div class="card-body">
			<h2 class="card-title flex items-center gap-2 text-xl">
				<span>{{ _tr('admin.header.title') }}</span>
			</h2>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { useI18n } from 'vue-i18n'
	import { _translations } from './_translations'

	const { t: _tr } = useI18n(_translations)
</script>
